<div class="btn-wrapper">
  <div
    class="loading-overlay"
    *ngIf="loading"
    fxLayout="row"
    fxLayoutAlign="center center"
  >
    <mat-spinner [diameter]="30"></mat-spinner>
  </div>

  <div
    class="btn-background-anim"
    [@slide-down]="animationUp ? 'up' : 'down'"
    fxLayout="row"
    fxLayoutAlign="center center"
    (@slide-down.done)="moveBackgroundUp()"
  >
    <br />
    <div class="title">{{ title }}</div>
  </div>
  <div class="animation-wrapper">
    <ng-lottie
      (animationCreated)="onAnimationLoaded($event)"
      (complete)="onComplete($event)"
      [options]="animationOptions"
      [style]="animStyle"
      class="#animation"
    >
    </ng-lottie>
  </div>
</div>
